import React from "react";
import CreateContentField from "./CreateContentField";
import { Box, Card, Switch, TextField } from "@material-ui/core";
import Collapse from "@material-ui/core/Collapse";
import { DreamHomeModel } from "../../../types/generalContent";
import { CollapseState } from "../GeneralContent";
import AddIcon from "@material-ui/icons/AddCircleOutline";
import RemoveIcon from "@material-ui/icons/RemoveCircleOutline";
import UpIcon from "@material-ui/icons/ArrowDropUp";
import DownIcon from "@material-ui/icons/ArrowDropDown";

interface DreamHomeCardsProps {
  state: DreamHomeModel;
  collapseState: CollapseState;
  toggleCard: (name: string) => void;
  errors: Record<string, string>;
  handleChange: (e: any) => void;
  handleAddInfoDescription: (name: string, category: string) => void;
  handleRemoveInfoDescriptionItem: (i: string, j: string) => void;
  handleRemoveContentIconItem: (id: string, name: string) => void;
  handleRemoveContentDescriptionItem: (
    i: number,
    name: string,
    category: string
  ) => void;
  handleChangeItemStatus: (name: string, state: boolean) => void;
  moveAccordionItem: (index: number, direction: "up" | "down") => void;
  handleRemoveAccordionItem: (id: string) => void;
  handleRemoveTimeLineDescriptionItem: (i: number, id: string) => void;
  handleRemoveGalleryItem: (i: number, name: string) => void;
  handleRemoveDrawLineDescriptionItem: (i: number, id: string) => void;
}

const DreamHomeCards = ({
  state,
  collapseState,
  toggleCard,
  errors,
  handleChange,
  handleAddInfoDescription,
  handleRemoveInfoDescriptionItem,
  handleRemoveContentIconItem,
  handleRemoveContentDescriptionItem,
  handleChangeItemStatus,
  moveAccordionItem,
  handleRemoveAccordionItem,
  handleRemoveTimeLineDescriptionItem,
  handleRemoveGalleryItem,
  handleRemoveDrawLineDescriptionItem,
}: DreamHomeCardsProps) => {
  return (
    <div className="content__section">
      <h2 className="content__subtitle">Home Page:</h2>
      <Box className="content__box">
        <Card className="content__card">
          <span
            className={`content__card-label ${
              collapseState.dhVideo ? "open" : "close"
            }`}
            onClick={() => toggleCard("dhVideo")}
          >
            Video
          </span>
          <Collapse in={collapseState.dhVideo}>
            <div className="content__fields-row">
              <CreateContentField
                fieldTitle="Title:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="dreamHome.video.title"
                      error={!!errors[`dreamHome.video.title`]}
                      helperText={errors[`dreamHome.video.title`]}
                      onChange={handleChange}
                      value={state.video.title}
                    />
                  </Box>
                }
              />
              <CreateContentField
                fieldTitle="Badge Price:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="dreamHome.video.badgePrice"
                      onChange={handleChange}
                      value={state.video.badgePrice}
                    />
                  </Box>
                }
              />
              <CreateContentField
                fieldTitle="Badge URL:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="dreamHome.video.badgeUrl"
                      onChange={handleChange}
                      value={state.video.badgeUrl}
                    />
                  </Box>
                }
              />
            </div>

            <div className="content__fields-row">
              <CreateContentField
                fieldTitle="Video URL:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="dreamHome.video.videoDesktopUrl"
                      error={!!errors[`dreamHome.video.videoDesktopUrl`]}
                      helperText={errors[`dreamHome.video.videoDesktopUrl`]}
                      onChange={handleChange}
                      value={state.video.videoDesktopUrl}
                    />
                  </Box>
                }
              />
              <CreateContentField
                fieldTitle="Video Mobile URL:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="dreamHome.video.videoMobileUrl"
                      error={!!errors[`dreamHome.video.videoMobileUrl`]}
                      helperText={errors[`dreamHome.video.videoMobileUrl`]}
                      onChange={handleChange}
                      value={state.video.videoMobileUrl}
                    />
                  </Box>
                }
              />
            </div>

            <div className="content__fields-row">
              <CreateContentField
                fieldTitle="Video Preview URL:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="dreamHome.video.videoPreviewUrl"
                      error={!!errors[`dreamHome.video.videoPreviewUrl`]}
                      helperText={errors[`dreamHome.video.videoPreviewUrl`]}
                      onChange={handleChange}
                      value={state.video.videoPreviewUrl}
                    />
                  </Box>
                }
              />
              <CreateContentField
                fieldTitle="Video Preview Mobile URL:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="dreamHome.video.videoPreviewMobileUrl"
                      error={!!errors[`dreamHome.video.videoPreviewMobileUrl`]}
                      helperText={
                        errors[`dreamHome.video.videoPreviewMobileUrl`]
                      }
                      onChange={handleChange}
                      value={state.video.videoPreviewMobileUrl}
                    />
                  </Box>
                }
              />
            </div>

            <div className="content__fields-row">
              <CreateContentField
                fieldTitle="Floor Plan URL:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="dreamHome.floorPlanUrl"
                      error={!!errors[`dreamHome.floorPlanUrl`]}
                      helperText={errors[`dreamHome.floorPlanUrl`]}
                      onChange={handleChange}
                      value={state.floorPlanUrl}
                    />
                  </Box>
                }
              />
              <CreateContentField
                fieldTitle="Floor Plan Mobile URL:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="dreamHome.floorPlanMobileUrl"
                      error={!!errors[`dreamHome.floorPlanMobileUrl`]}
                      helperText={errors[`dreamHome.floorPlanMobileUrl`]}
                      onChange={handleChange}
                      value={state.floorPlanMobileUrl}
                    />
                  </Box>
                }
              />
            </div>
          </Collapse>
        </Card>

        <Card className="content__card">
          <span
            className={`content__card-label ${
              collapseState.dhInfo ? "open" : "close"
            }`}
            onClick={() => toggleCard("dhInfo")}
          >
            Info
          </span>
          <Collapse in={collapseState.dhInfo}>
            {state.info.map((info, i) => {
              return (
                <div className="content__fields-item" key={info._id}>
                  <div className="content__fields-row">
                    <CreateContentField
                      fieldTitle="Title:"
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`dreamHome.info[${i}].title`}
                            error={!!errors[`dreamHome.info[${i}].title`]}
                            helperText={errors[`dreamHome.info[${i}].title`]}
                            onChange={handleChange}
                            value={state.info[i].title}
                          />
                        </Box>
                      }
                    />
                    <button
                      className="content__add-btn"
                      type="button"
                      onClick={() =>
                        handleAddInfoDescription(
                          `dreamHome.info[${i}].description[${info.description.length}]`,
                          "info"
                        )
                      }
                    >
                      <AddIcon />
                    </button>
                  </div>

                  {info.description.map((descr, j) => {
                    return (
                      <div
                        className="content__fields-list-item"
                        key={descr._id}
                      >
                        <div className="content__fields-row">
                          <CreateContentField
                            fieldTitle="Subtitle:"
                            field={
                              <Box>
                                <TextField
                                  label=""
                                  size="small"
                                  variant="outlined"
                                  type="text"
                                  name={`dreamHome.info[${i}].description[${j}].subtitle`}
                                  error={
                                    !!errors[
                                      `dreamHome.info[${i}].description[${j}].subtitle`
                                    ]
                                  }
                                  helperText={
                                    errors[
                                      `dreamHome.info[${i}].description[${j}].subtitle`
                                    ]
                                  }
                                  onChange={handleChange}
                                  value={
                                    state.info[i].description[j]
                                      .subtitle
                                  }
                                />
                              </Box>
                            }
                          />
                          <CreateContentField
                            fieldTitle="Text:"
                            field={
                              <Box>
                                <TextField
                                  label=""
                                  size="small"
                                  variant="outlined"
                                  type="text"
                                  name={`dreamHome.info[${i}].description[${j}].text`}
                                  error={
                                    !!errors[
                                      `dreamHome.info[${i}].description[${j}].text`
                                    ]
                                  }
                                  helperText={
                                    errors[
                                      `dreamHome.info[${i}].description[${j}].text`
                                    ]
                                  }
                                  onChange={handleChange}
                                  value={
                                    state.info[i].description[j].text
                                  }
                                />
                              </Box>
                            }
                          />
                          <CreateContentField
                            fieldTitle="Icon URL:"
                            field={
                              <Box>
                                <TextField
                                  label=""
                                  size="small"
                                  variant="outlined"
                                  type="text"
                                  name={`dreamHome.info[${i}].description[${j}].iconUrl`}
                                  error={
                                    !!errors[
                                      `dreamHome.info[${i}].description[${j}].iconUrl`
                                    ]
                                  }
                                  helperText={
                                    errors[
                                      `dreamHome.info[${i}].description[${j}].iconUrl`
                                    ]
                                  }
                                  onChange={handleChange}
                                  value={
                                    state.info[i].description[j]
                                      .iconUrl
                                  }
                                />
                              </Box>
                            }
                          />
                          {info.description.length > 1 && (
                            <button
                              className="content__delete-btn"
                              type="button"
                              onClick={() =>
                                handleRemoveInfoDescriptionItem(
                                  info._id,
                                  descr._id
                                )
                              }
                            >
                              <RemoveIcon />
                            </button>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </Collapse>
        </Card>

        <Card className="content__card">
          <span
            className={`content__card-label ${
              collapseState.dhContent ? "open" : "close"
            }`}
            onClick={() => toggleCard("dhContent")}
          >
            Key Highlights
          </span>
          <Collapse in={collapseState.dhContent}>
            <div className="content__fields-row">
              <CreateContentField
                fieldTitle="Title:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="dreamHome.content.title"
                      error={!!errors[`dreamHome.content.title`]}
                      helperText={errors[`dreamHome.content.title`]}
                      onChange={handleChange}
                      value={state.content.title}
                    />
                  </Box>
                }
              />
              <CreateContentField
                fieldTitle="Subtitle:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="dreamHome.content.subtitle"
                      error={!!errors[`dreamHome.content.subtitle`]}
                      helperText={errors[`dreamHome.content.subtitle`]}
                      onChange={handleChange}
                      value={state.content.subtitle}
                    />
                  </Box>
                }
              />
            </div>
            <div className="content__fields-row centered">
              <span className="content__item-label">Icons:</span>
              <button
                className="content__add-btn centered"
                type="button"
                onClick={() =>
                  handleAddInfoDescription(
                    `dreamHome.content.icons[${state.content.icons.length}]`,
                    "icon"
                  )
                }
              >
                <AddIcon />
              </button>
            </div>
            {state.content.icons.map((icon, i) => {
              return (
                <div className="content__fields-list-item" key={icon._id}>
                  <div className="content__fields-row">
                    <CreateContentField
                      fieldTitle="Icon Title:"
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`dreamHome.content.icons[${i}].iconTitle`}
                            error={
                              !!errors[
                                `dreamHome.content.icons[${i}].iconTitle`
                              ]
                            }
                            helperText={
                              errors[`dreamHome.content.icons[${i}].iconTitle`]
                            }
                            onChange={handleChange}
                            value={state.content.icons[i].iconTitle}
                          />
                        </Box>
                      }
                    />
                    <CreateContentField
                      fieldTitle="Icon URL:"
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`dreamHome.content.icons[${i}].iconUrl`}
                            error={
                              !!errors[`dreamHome.content.icons[${i}].iconUrl`]
                            }
                            helperText={
                              errors[`dreamHome.content.icons[${i}].iconUrl`]
                            }
                            onChange={handleChange}
                            value={state.content.icons[i].iconUrl}
                          />
                        </Box>
                      }
                    />
                    <CreateContentField
                      fieldTitle="Icon Description:"
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`dreamHome.content.icons[${i}].iconDescription`}
                            error={
                              !!errors[
                                `dreamHome.content.icons[${i}].iconDescription`
                              ]
                            }
                            helperText={
                              errors[
                                `dreamHome.content.icons[${i}].iconDescription`
                              ]
                            }
                            onChange={handleChange}
                            value={
                              state.content.icons[i]
                                .iconDescription || ""
                            }
                          />
                        </Box>
                      }
                    />
                    {state.content.icons.length > 1 && (
                      <button
                        className="content__delete-btn"
                        type="button"
                        onClick={() =>
                          handleRemoveContentIconItem(icon._id, "dreamHome")
                        }
                      >
                        <RemoveIcon />
                      </button>
                    )}
                  </div>
                </div>
              );
            })}

            <div className="content__fields-row centered">
              <span className="content__item-label">Description:</span>
              <button
                className="content__add-btn centered"
                type="button"
                onClick={() =>
                  handleAddInfoDescription(
                    `dreamHome.content.description[${state.content.description.length}]`,
                    "description"
                  )
                }
              >
                <AddIcon />
              </button>
            </div>
            {state.content.description.map((descr, i) => {
              return (
                <div className="content__fields-list-item" key={i}>
                  <div className="content__fields-row">
                    <CreateContentField
                      fieldTitle=""
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`dreamHome.content.description[${i}]`}
                            error={
                              !!errors[`dreamHome.content.description[${i}]`]
                            }
                            helperText={
                              errors[`dreamHome.content.description[${i}]`]
                            }
                            onChange={handleChange}
                            value={descr}
                          />
                        </Box>
                      }
                    />
                    {state.content.description.length > 1 && (
                      <button
                        className="content__delete-btn centered"
                        type="button"
                        onClick={() =>
                          handleRemoveContentDescriptionItem(
                            i,
                            "description",
                            "dreamHome"
                          )
                        }
                      >
                        <RemoveIcon />
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
            <span className="content__item-label">Image:</span>
            <div className="content__fields-row">
              <CreateContentField
                fieldTitle="image URL:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="dreamHome.content.imageUrl"
                      error={!!errors[`dreamHome.content.imageUrl`]}
                      helperText={errors[`dreamHome.content.imageUrl`]}
                      onChange={handleChange}
                      value={state.content.imageUrl}
                    />
                  </Box>
                }
              />
              <CreateContentField
                fieldTitle="image x2 URL:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="dreamHome.content.imageX2Url"
                      error={!!errors[`dreamHome.content.imageX2Url`]}
                      helperText={errors[`dreamHome.content.imageX2Url`]}
                      onChange={handleChange}
                      value={state.content.imageX2Url}
                    />
                  </Box>
                }
              />
            </div>
            <div className="content__fields-row">
              <CreateContentField
                fieldTitle="image Mobile URL:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="dreamHome.content.imageMobileUrl"
                      error={!!errors[`dreamHome.content.imageMobileUrl`]}
                      helperText={errors[`dreamHome.content.imageMobileUrl`]}
                      onChange={handleChange}
                      value={state.content.imageMobileUrl}
                    />
                  </Box>
                }
              />
              <CreateContentField
                fieldTitle="image Mobile x2 URL:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="dreamHome.content.imageMobileX2Url"
                      error={!!errors[`dreamHome.content.imageMobileX2Url`]}
                      helperText={errors[`dreamHome.content.imageMobileX2Url`]}
                      onChange={handleChange}
                      value={state.content.imageMobileX2Url}
                    />
                  </Box>
                }
              />
            </div>

            <div className="content__fields-row centered">
              <span className="content__item-label">Image Text:</span>
              <button
                className="content__add-btn centered"
                type="button"
                onClick={() =>
                  handleAddInfoDescription(
                    `dreamHome.content.imageText[${state.content.imageText.length}]`,
                    "description"
                  )
                }
              >
                <AddIcon />
              </button>
            </div>
            {state.content.imageText.map((text, i) => {
              return (
                <div className="content__fields-list-item" key={i}>
                  <div className="content__fields-row">
                    <CreateContentField
                      fieldTitle=""
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`dreamHome.content.imageText[${i}]`}
                            error={
                              !!errors[`dreamHome.content.imageText[${i}]`]
                            }
                            helperText={
                              errors[`dreamHome.content.imageText[${i}]`]
                            }
                            onChange={handleChange}
                            value={text}
                          />
                        </Box>
                      }
                    />
                    {state.content.imageText.length > 1 && (
                      <button
                        className="content__delete-btn centered"
                        type="button"
                        onClick={() =>
                          handleRemoveContentDescriptionItem(
                            i,
                            "imageText",
                            "dreamHome"
                          )
                        }
                      >
                        <RemoveIcon />
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
          </Collapse>
        </Card>

        <Card className="content__card">
          <span
            className={`content__card-label ${
              collapseState.dhAccordionData ? "open" : "close"
            }`}
            onClick={() => toggleCard("dhAccordionData")}
          >
            Accordion
          </span>
          <Collapse in={collapseState.dhAccordionData}>
            <div className="content__fields-row centered">
              <span className="content__item-label">accordion items:</span>
              <button
                className="content__add-btn centered"
                type="button"
                onClick={() =>
                  handleAddInfoDescription(
                    `dreamHome.accordionData[${state.accordionData.length}]`,
                    "accordion"
                  )
                }
              >
                <AddIcon />
              </button>
            </div>
            {state.accordionData.map((acc, i) => {
              return (
                <div className="content__fields-list-item" key={i}>
                  <div className="content__fields-row">
                    <CreateContentField
                      fieldTitle="Title"
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`dreamHome.accordionData[${i}].title`}
                            error={
                              !!errors[`dreamHome.accordionData[${i}].title`]
                            }
                            helperText={
                              errors[`dreamHome.accordionData[${i}].title`]
                            }
                            onChange={handleChange}
                            value={acc.title}
                          />
                        </Box>
                      }
                    />
                    <CreateContentField
                      fieldTitle="Icon URL"
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`dreamHome.accordionData[${i}].iconUrl`}
                            error={
                              !!errors[`dreamHome.accordionData[${i}].iconUrl`]
                            }
                            helperText={
                              errors[`dreamHome.accordionData[${i}].iconUrl`]
                            }
                            onChange={handleChange}
                            value={acc.iconUrl}
                          />
                        </Box>
                      }
                    />
                    <CreateContentField
                      fieldTitle="Special"
                      field={
                        <Box>
                          <Switch
                            checked={acc.isSpecial || false}
                            onChange={() =>
                              handleChangeItemStatus(
                                `dreamHome.accordionData[${i}].isSpecial`,
                                acc.isSpecial || false
                              )
                            }
                            color="primary"
                            name="checkedB"
                            inputProps={{ "aria-label": "primary checkbox" }}
                          />
                        </Box>
                      }
                    />
                    {state.accordionData.length > 1 && (
                      <div className="content__position-btns">
                        <button
                          className="content__position-btn"
                          type="button"
                          onClick={() => moveAccordionItem(i, "up")}
                        >
                          <UpIcon />
                        </button>
                        <button
                          className="content__position-btn"
                          type="button"
                          onClick={() => moveAccordionItem(i, "down")}
                        >
                          <DownIcon />
                        </button>
                      </div>
                    )}
                    {state.accordionData.length > 1 && (
                      <button
                        className="content__delete-btn"
                        type="button"
                        onClick={() => handleRemoveAccordionItem(acc._id)}
                      >
                        <RemoveIcon />
                      </button>
                    )}
                  </div>
                  <CreateContentField
                    fieldTitle="Description"
                    field={
                      <Box>
                        <TextField
                          label=""
                          size="small"
                          variant="outlined"
                          type="text"
                          name={`dreamHome.accordionData[${i}].description`}
                          error={
                            !!errors[
                              `dreamHome.accordionData[${i}].description`
                            ]
                          }
                          helperText={
                            errors[`dreamHome.accordionData[${i}].description`]
                          }
                          onChange={handleChange}
                          value={acc.description}
                        />
                      </Box>
                    }
                  />
                </div>
              );
            })}
          </Collapse>
        </Card>

        <Card className="content__card">
          <span
            className={`content__card-label ${
              collapseState.dhDrawLine ? "open" : "close"
            }`}
            onClick={() => toggleCard("dhDrawLine")}
          >
            Drawline
          </span>
          <Collapse in={collapseState.dhDrawLine}>
            <div className="content__fields-row">
              <CreateContentField
                fieldTitle="Title:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="dreamHome.drawLine.title"
                      error={!!errors[`dreamHome.drawLine.title`]}
                      helperText={errors[`dreamHome.drawLine.title`]}
                      onChange={handleChange}
                      value={state.drawLine.title}
                    />
                  </Box>
                }
              />
            </div>
            <div className="content__fields-row">
              <CreateContentField
                fieldTitle="Description:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="dreamHome.drawLine.description"
                      error={!!errors[`dreamHome.drawLine.description`]}
                      helperText={errors[`dreamHome.drawLine.description`]}
                      onChange={handleChange}
                      value={state.drawLine.description}
                    />
                  </Box>
                }
              />
              <CreateContentField
                fieldTitle="Footer text:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="dreamHome.drawLine.footerText"
                      onChange={handleChange}
                      value={state.drawLine.footerText}
                    />
                  </Box>
                }
              />
            </div>

            <div className="content__fields-row centered">
              <span className="content__item-label">Stepper:</span>
            </div>
            {state.drawLine.stepper.map((step, i) => {
              return (
                <div className="content__fields-item" key={step._id}>
                  <div className="content__fields-row">
                    <CreateContentField
                      fieldTitle="Title:"
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`dreamHome.drawLine.stepper[${i}].title`}
                            error={
                              !!errors[`dreamHome.drawLine.stepper[${i}].title`]
                            }
                            helperText={
                              errors[`dreamHome.drawLine.stepper[${i}].title`]
                            }
                            onChange={handleChange}
                            value={step.title}
                          />
                        </Box>
                      }
                    />
                    <CreateContentField
                      fieldTitle="Icon URL:"
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`dreamHome.drawLine.stepper[${i}].iconUrl`}
                            error={
                              !!errors[
                                `dreamHome.drawLine.stepper[${i}].iconUrl`
                              ]
                            }
                            helperText={
                              errors[`dreamHome.drawLine.stepper[${i}].iconUrl`]
                            }
                            onChange={handleChange}
                            value={step.iconUrl}
                          />
                        </Box>
                      }
                    />
                    <CreateContentField
                      fieldTitle="Active"
                      field={
                        <Box>
                          <Switch
                            checked={step.isActive || false}
                            onChange={() =>
                              handleChangeItemStatus(
                                `dreamHome.drawLine.stepper[${i}].isActive`,
                                step.isActive || false
                              )
                            }
                            color="primary"
                            name="checkedB"
                            inputProps={{ "aria-label": "primary checkbox" }}
                          />
                        </Box>
                      }
                    />
                  </div>
                  <div className="content__fields-row centered">
                    <span className="content__item-label">Description:</span>
                    <button
                      className="content__add-btn centered"
                      type="button"
                      onClick={() =>
                        handleAddInfoDescription(
                          `dreamHome.drawLine.stepper[${i}].description[${step.description.length}]`,
                          "description"
                        )
                      }
                    >
                      <AddIcon />
                    </button>
                  </div>
                  {step.description.map((descr, j) => {
                    return (
                      <div className="content__fields-list-item" key={j}>
                        <div className="content__fields-row">
                          <CreateContentField
                            fieldTitle=""
                            field={
                              <Box>
                                <TextField
                                  label=""
                                  size="small"
                                  variant="outlined"
                                  type="text"
                                  name={`dreamHome.drawLine.stepper[${i}].description[${j}]`}
                                  error={
                                    !!errors[
                                      `dreamHome.drawLine.stepper[${i}].description[${j}]`
                                    ]
                                  }
                                  helperText={
                                    errors[
                                      `dreamHome.drawLine.stepper[${i}].description[${j}]`
                                    ]
                                  }
                                  onChange={handleChange}
                                  value={descr}
                                />
                              </Box>
                            }
                          />
                          {state.content.description.length > 1 && (
                            <button
                              className="content__delete-btn centered"
                              type="button"
                              onClick={() =>
                                handleRemoveDrawLineDescriptionItem(j, step._id)
                              }
                            >
                              <RemoveIcon />
                            </button>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </Collapse>
        </Card>

        <Card className="content__card">
          <span
            className={`content__card-label ${
              collapseState.dhTimeLine ? "open" : "close"
            }`}
            onClick={() => toggleCard("dhTimeLine")}
          >
            Timeline
          </span>
          <Collapse in={collapseState.dhTimeLine}>
            <div className="content__fields-row">
              <CreateContentField
                fieldTitle="Title:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="dreamHome.timeLine.title"
                      error={!!errors[`dreamHome.timeLine.title`]}
                      helperText={errors[`dreamHome.timeLine.title`]}
                      onChange={handleChange}
                      value={state.timeLine.title}
                    />
                  </Box>
                }
              />
              <CreateContentField
                fieldTitle="Badge text:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="dreamHome.timeLine.specialBadge"
                      onChange={handleChange}
                      value={state.timeLine.specialBadge}
                    />
                  </Box>
                }
              />
            </div>
            <div className="content__fields-row">
              <CreateContentField
                fieldTitle="Description:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="dreamHome.timeLine.description"
                      error={!!errors[`dreamHome.timeLine.description`]}
                      helperText={errors[`dreamHome.timeLine.description`]}
                      onChange={handleChange}
                      value={state.timeLine.description}
                    />
                  </Box>
                }
              />
              <CreateContentField
                fieldTitle="Footer text:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="dreamHome.timeLine.footerText"
                      onChange={handleChange}
                      value={state.timeLine.footerText}
                    />
                  </Box>
                }
              />
            </div>

            <span className="content__item-label">Stepper:</span>
            {state.timeLine.stepper.map((step, i) => {
              return (
                <div className="content__fields-item" key={step._id}>
                  <div className="content__fields-row">
                    <CreateContentField
                      fieldTitle="Title:"
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`dreamHome.timeLine.stepper[${i}].title`}
                            error={
                              !!errors[`dreamHome.timeLine.stepper[${i}].title`]
                            }
                            helperText={
                              errors[`dreamHome.timeLine.stepper[${i}].title`]
                            }
                            onChange={handleChange}
                            value={step.title}
                          />
                        </Box>
                      }
                    />
                    <CreateContentField
                      fieldTitle="Icon URL:"
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`dreamHome.timeLine.stepper[${i}].iconUrl`}
                            error={
                              !!errors[
                                `dreamHome.timeLine.stepper[${i}].iconUrl`
                              ]
                            }
                            helperText={
                              errors[`dreamHome.timeLine.stepper[${i}].iconUrl`]
                            }
                            onChange={handleChange}
                            value={step.iconUrl}
                          />
                        </Box>
                      }
                    />
                  </div>
                  <div className="content__fields-row centered">
                    <span className="content__item-label">Description:</span>
                    <button
                      className="content__add-btn centered"
                      type="button"
                      onClick={() =>
                        handleAddInfoDescription(
                          `dreamHome.timeLine.stepper[${i}].description[${step.description.length}]`,
                          "description"
                        )
                      }
                    >
                      <AddIcon />
                    </button>
                  </div>
                  {step.description.map((descr, j) => {
                    return (
                      <div className="content__fields-list-item" key={j}>
                        <div className="content__fields-row">
                          <CreateContentField
                            fieldTitle=""
                            field={
                              <Box>
                                <TextField
                                  label=""
                                  size="small"
                                  variant="outlined"
                                  type="text"
                                  name={`dreamHome.timeLine.stepper[${i}].description[${j}]`}
                                  error={
                                    !!errors[
                                      `dreamHome.timeLine.stepper[${i}].description[${j}]`
                                    ]
                                  }
                                  helperText={
                                    errors[
                                      `dreamHome.timeLine.stepper[${i}].description[${j}]`
                                    ]
                                  }
                                  onChange={handleChange}
                                  value={descr}
                                />
                              </Box>
                            }
                          />
                          {state.content.description.length > 1 && (
                            <button
                              className="content__delete-btn centered"
                              type="button"
                              onClick={() =>
                                handleRemoveTimeLineDescriptionItem(j, step._id)
                              }
                            >
                              <RemoveIcon />
                            </button>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </Collapse>
        </Card>

        <Card className="content__card">
          <span
            className={`content__card-label ${
              collapseState.dhEarlyBird ? "open" : "close"
            }`}
            onClick={() => toggleCard("dhEarlyBird")}
          >
            Early Bird
          </span>
          <Collapse in={collapseState.dhEarlyBird}>
          <div className="content__fields-row">
            <CreateContentField
                fieldTitle="video URL:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="dreamHome.bonusDraw.videoUrl"
                      onChange={handleChange}
                      value={state.bonusDraw.videoUrl || ""}
                    />
                  </Box>
                }
              />
              <CreateContentField
                fieldTitle="video preview URL:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="dreamHome.bonusDraw.videoPreviewUrl"
                      onChange={handleChange}
                      value={state.bonusDraw.videoPreviewUrl || ""}
                    />
                  </Box>
                }
              />
          </div>
          </Collapse>
        </Card>

        <Card className="content__card">
          <span
            className={`content__card-label ${
              collapseState.dhGallery ? "open" : "close"
            }`}
            onClick={() => toggleCard("dhGallery")}
          >
            Gallery
          </span>
          <Collapse in={collapseState.dhGallery}>
            <div className="content__fields-row centered">
              <span className="content__item-label">
                gallery slides({state.gallery.length}):
              </span>
              <button
                className="content__add-btn centered"
                type="button"
                onClick={() =>
                  handleAddInfoDescription(
                    `dreamHome.gallery[${state.gallery.length}]`,
                    "gallery"
                  )
                }
              >
                <AddIcon />
              </button>
            </div>
            {state.gallery.map((slide, i) => {
              return (
                <div className="content__fields-item" key={i}>
                  <div className="content__fields-row">
                    <CreateContentField
                      fieldTitle="Title:"
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`dreamHome.gallery[${i}].title`}
                            error={!!errors[`dreamHome.gallery[${i}].title`]}
                            helperText={errors[`dreamHome.gallery[${i}].title`]}
                            onChange={handleChange}
                            value={slide.title}
                          />
                        </Box>
                      }
                    />
                    <CreateContentField
                      fieldTitle="Description:"
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`dreamHome.gallery[${i}].description`}
                            error={
                              !!errors[`dreamHome.gallery[${i}].description`]
                            }
                            helperText={
                              errors[`dreamHome.gallery[${i}].description`]
                            }
                            onChange={handleChange}
                            value={slide.description}
                          />
                        </Box>
                      }
                    />
                    {state.gallery.length > 1 && (
                      <button
                        className="content__delete-btn"
                        type="button"
                        onClick={() => handleRemoveGalleryItem(i, "dreamHome")}
                      >
                        <RemoveIcon />
                      </button>
                    )}
                  </div>
                  <div className="content__fields-row">
                    <CreateContentField
                      fieldTitle="image 800 URL:"
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`dreamHome.gallery[${i}].image800Url`}
                            error={
                              !!errors[`dreamHome.gallery[${i}].image800Url`]
                            }
                            helperText={
                              errors[`dreamHome.gallery[${i}].image800Url`]
                            }
                            onChange={handleChange}
                            value={slide.image800Url}
                          />
                        </Box>
                      }
                    />
                    <CreateContentField
                      fieldTitle="image 1600 URL:"
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`dreamHome.gallery[${i}].image1600Url`}
                            error={
                              !!errors[`dreamHome.gallery[${i}].image1600Url`]
                            }
                            helperText={
                              errors[`dreamHome.gallery[${i}].image1600Url`]
                            }
                            onChange={handleChange}
                            value={slide.image1600Url}
                          />
                        </Box>
                      }
                    />
                  </div>
                  <div className="content__fields-row">
                    <CreateContentField
                      fieldTitle="image 2048 URL:"
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`dreamHome.gallery[${i}].image2048Url`}
                            error={
                              !!errors[`dreamHome.gallery[${i}].image2048Url`]
                            }
                            helperText={
                              errors[`dreamHome.gallery[${i}].image2048Url`]
                            }
                            onChange={handleChange}
                            value={slide.image2048Url}
                          />
                        </Box>
                      }
                    />
                    <CreateContentField
                      fieldTitle="image 3840 URL:"
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`dreamHome.gallery[${i}].image3840Url`}
                            error={
                              !!errors[`dreamHome.gallery[${i}].image3840Url`]
                            }
                            helperText={
                              errors[`dreamHome.gallery[${i}].image3840Url`]
                            }
                            onChange={handleChange}
                            value={slide.image3840Url}
                          />
                        </Box>
                      }
                    />
                  </div>
                </div>
              );
            })}
          </Collapse>
        </Card>

        <Card className="content__card">
          <span
            className={`content__card-label ${
              collapseState.dhFaq ? "open" : "close"
            }`}
            onClick={() => toggleCard("dhFaq")}
          >
            FAQ
          </span>
          <Collapse in={collapseState.dhFaq}>
            <div className="content__fields-row">
              <CreateContentField
                fieldTitle="ImageURL:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="dreamHome.faq.imageUrl"
                      error={!!errors[`dreamHome.faq.imageUrl`]}
                      helperText={errors[`dreamHome.faq.imageUrl`]}
                      onChange={handleChange}
                      value={state.faq.imageUrl || ""}
                    />
                  </Box>
                }
              />
            </div>
          </Collapse>
        </Card>
      </Box>
    </div>
  );
};

export default DreamHomeCards;
